import { Component } from '@angular/core';

/* TODO: Temporary component for 404, should have an error module for handle it with UI defined */
@Component({
    template: '<h1>Page Not Found</h1>',
    standalone: false
})
export class NotFoundComponent {
}
